import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 20H7V18H8.927L13.043 6H11V4H17V6H15.073L10.957 18H13V20Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Italic"
);
